import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { InvoicesListPage } from '@/pages/invoicing/InvoicesListPage';
import { invoicingModeOf } from '@/hooks/useModuleAccess';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

// Server-driven filters: free-text search, a stored-status single-select, and an issued date range.
// Overdue is derived at read time from the rows, so it is not a server filter param.
const invoicesSearchSchema = z.object({
	search: z.string().optional(),
	status: z.enum(['DRAFT', 'ISSUED', 'PAID', 'CANCELLED']).optional(),
	source: z.enum(['VADIO', 'UPLOADED']).optional(),
	issuedFrom: z.string().optional(),
	issuedTo: z.string().optional(),
	page: z.coerce.number().optional(),
	pageSize: z.coerce.number().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/invoicing/')({
	beforeLoad: ({ context }) => {
		const disabledModules = context.globalStore.getState().currentCompany?.disabledModules;
		if (invoicingModeOf(disabledModules) === 'upload') throw redirect({ to: '/orders' });
		return requireAnyPermission({
			context,
			anyOf: ['invoicing.read.own', 'invoicing.read.all'],
			redirectTo: '/dashboard',
		});
	},
	component: InvoicesListPage,
	validateSearch: invoicesSearchSchema,
});
